/*
 * Task Type Invite Link - display instructions and a link.
 */
import React, { Component } from 'react';
//import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, TextField, Typography } from '@mui/material';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';


const styleSheet = theme => ({
  modelLabel: {
    color: theme.palette.secondary.main,
  },
  instructionText: {
    marginTop: 8,
  }

});

class TaskTypeInviteLink extends Component {
  componentDidMount() {
    if (this.props.setCompleteDisabled) {
      this.props.setCompleteDisabled(false);
    }
  }

  handleDoneFromParent () {
    // return a promise
    return Promise.resolve();
  }

  render() {
    const classes = this.props.classes;

    let theTask         = this.props.task;
    let theTaskTitle    = theTask.title;
    let theInstruction  = theTask.instruction;
    let theLinkName     = theTask.linkName;
    let theLinkUrl      = theTask.linkUrl;

    let theAppName = theTask.customerAppTByCustomerAppId.appTByAppId.appName;
    let theAccountName = theTask.customerAppTByCustomerAppId.accountTByProvisioningAccountId.accountName;

    // If a title has been provided, we'll use that.  Otherwise, we'll create a default title.
    let usePassedTitle = true;
    let theTitle = null;
    if (theTaskTitle != null && theTaskTitle.length > 2) {
      theTitle = theTaskTitle;
    } else if (this.props.title != null && this.props.title.length > 0) {
      theTitle = this.props.title;
    } else if (theAppName != null && theAccountName != null) {
      usePassedTitle = false;
    } else {
      theTitle = 'Please invite our team';
    }

    // The invite link should have a JSON object of email notes in taskData.
    let taskData = theTask.taskData;

    let theEmailInvitation = null;
    let addressArray = [];
    //let whoToInvite = 'the team';
    if (taskData != null && taskData.inviteEmails != null && taskData.inviteEmails.length > 0) {
      let emailArray = taskData.inviteEmails;
      for (let i=0; i<emailArray.length; i++) {
        let emailObj = emailArray[i];
        if (emailObj.checked === true) {
          addressArray.push(emailObj.email);
        }
      }
    }
    if (addressArray.length === 0) {
      theEmailInvitation = 'Please invite the team to your ' + theAppName + ' account.';
    }

    let addrCount = 0;

    let donePrepend = "You've invited";
    if (this.props.done === false) {
      donePrepend = 'Please invite';
    }

    return (
      <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
        <Grid item xs={12}>
          <Grid container spacing={1} justifyContent="flex-start" alignItems="center">

            {usePassedTitle === true &&
            <Grid item xs={12}>
              <Typography variant="h6">{theTitle}</Typography>
            </Grid>}
            {/*usePassedTitle === false &&
            <Grid item xs={12}>
              <Typography variant="body1" style={{fontSize: 16}}>{theTitleStart}<strong>{theTitleCta}</strong>{theTitleEnd}</Typography>
            </Grid>*/}
            {theEmailInvitation != null &&
            <Grid item xs={12}>
              <Typography variant="body1">{theEmailInvitation}</Typography>
            </Grid>}
            {theEmailInvitation === null &&
            <Grid item xs={12}>
              <Typography variant="body1">
                {donePrepend}&nbsp;
                {addressArray.map(n => {
                  let theEmail = addressArray[addrCount];
                  let thePrepend = '';
                  if (addrCount > 0) {
                    if (addrCount === addressArray.length - 1) {
                      if (addressArray.length > 2) {
                        thePrepend = ',';
                      }
                      thePrepend = thePrepend + ' and ';
                    } else {
                      thePrepend = ', ';
                    }
                  }
                  
                  addrCount++;

                  return (
                    <span key={addrCount}>{thePrepend}<strong>{theEmail}</strong></span>
                  );
                })}
                &nbsp;to your {theAppName} account.
              </Typography>
            </Grid>}
            {theInstruction != null && theInstruction.length > 0 && this.props.done === false &&
            <Grid item xs={12}>
              <TextField
                className={classes.instructionText}
                value={theInstruction}
                label="Instructions"
                variant="filled"
                multiline
                minRows={2}
                maxRows={5}
              />
            </Grid>}
          </Grid>
        </Grid>
        {theLinkName != null && theLinkName.length > 0 && theLinkUrl != null && theLinkUrl.length > 0 && this.props.done === false &&
        <Grid item xs={12}>
          <Link href={theLinkUrl} underline="always" target="_blank">
            <Grid container spacing={0.5} justifyContent="flex-start" alignItems="center">
              <Grid item><LinkOutlinedIcon className={classes.modelLabel} sx={{verticalAlign:'middle', mr:0.5}}/></Grid>
              <Grid item><Typography className={classes.modelLabel} variant="body1">{theLinkName}</Typography></Grid>
            </Grid>
          </Link>
        </Grid>}
      </Grid>
    );
  }
}

TaskTypeInviteLink.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(TaskTypeInviteLink);;
